import { CSSProperties, FC } from 'react';
import { Tag } from 'antd';

import { ScenarioStatus as ScenarioStatusType } from '@/shared/api/types';
import { COLORS } from '@/shared/constants/colors';

import { getStatusName } from '../helpers';

type ScenarioStatusProps = {
  status: ScenarioStatusType;
};

export const ScenarioStatus: FC<ScenarioStatusProps> = ({ status }) => (
  <Tag style={{ textTransform: 'uppercase', ...getColorsByStatus(status) }}>
    {getStatusName(status)}
  </Tag>
);

const getColorsByStatus = (status: ScenarioStatusType): CSSProperties => {
  switch (status) {
    case ScenarioStatusType.Active:
    case ScenarioStatusType.InProgress:
      return COLORS.scenarios.ACTIVE;

    case ScenarioStatusType.Done:
      return COLORS.scenarios.DONE;

    case ScenarioStatusType.Draft:
    case ScenarioStatusType.Canceled:
    default:
      return COLORS.scenarios.DRAFT;
  }
};
